import apiClient from './client'

/**
 * 订单相关 API
 */
export const orderApi = {
  /**
   * 创建订单
   * @param {Object} data - 订单数据
   * @param {string} data.NotificationEmail - 通知邮箱
   * @param {string} data.ProductId - 产品ID
   * @returns {Promise} 创建订单响应
   */
  createOrder(data) {
    return apiClient.post('/orders/create-order/', {
      NotificationEmail: data.NotificationEmail,
      ProductId: data.ProductId,
      CouponId: data.CouponId,
      DiscountCode: data.DiscountCode,
      StartDate: data.StartDate,
      ImpactClickId: data.ImpactClickId
    })
  },

  /**
   * 获取订单价格详情（包含优惠券计算）
   * @param {Object} params - 参数
   * @param {string} params.product_id - 产品ID
   * @param {string} [params.coupon_id] - 优惠券ID (可选)
   * @returns {Promise} 价格详情响应
   */
  getPrice(params) {
    return apiClient.get('/orders/get-price', { params })
  },

  /**
   * 查询我的订单列表
   * @param {Object} params - 查询参数
   * @param {number} params.page_index - 页码
   * @param {number} params.page_size - 每页数量
   * @param {number} [params.status_code] - 状态码（可选）
   * @returns {Promise} 订单列表响应
   */
  queryOrderList(params) {
    return apiClient.get('/orders/me/query-order-list/', { params })
  },

  /**
   * 创建 Cobo 订单支付链接
   * @param {Object} data - 订单数据
   * @param {string} data.order_no - 订单号
   * @returns {Promise} 创建支付响应
   */
  createCoboOrderPayment(data) {
    return apiClient.post('/cobo/pay/order', data)
  },

  /**
   * 创建数据库订单
   * @param {Object} data - 订单数据
   * @param {string} data.userId - 用户ID
   * @param {string} data.productId - 产品ID
   * @param {string} data.email - 邮箱
   * @param {string} [data.invitationCode] - 邀请码（可选）
   * @returns {Promise} 创建订单响应
   */
  createDbOrder(data) {
    return apiClient.post('/create-db-order/', data)
  },

  /**
   * 开卡
   * @param {Object} data - 开卡数据
   * @param {string} data.orderNo - 订单号
   * @returns {Promise} 开卡响应
   */
  openCard(data) {
    return apiClient.post('/open-card/', data)
  },

  /**
   * 获取 eSIM 详情（卡密）
   * @param {string} orderNo - 订单号
   * @returns {Promise} eSIM 详情响应
   */
  getEsimDetail(orderNo) {
    return apiClient.post(`/esims/get-esim-detail/?order_no=${orderNo}`)
  },

  /**
   * 查询 eSIM 流量使用情况
   * @param {string} orderNo - 订单号
   * @param {Object} [options] - 可选配置
   * @param {boolean} [options.skipLoading=false] - 是否跳过全局 loading
   * @returns {Promise} eSIM 流量使用情况响应
   */
  getEsimUsage(orderNo, options = {}) {
    return apiClient.get('/esims/usage/', {
      params: { order_no: orderNo },
      skipLoading: options.skipLoading || false,
      skipErrorHandler: options.skipErrorHandler || false
    })
  },

  /**
   * 查询订单状态
   * @param {string} orderNo - 订单号
   * @param {Object} [options] - 可选配置
   * @param {boolean} [options.skipLoading=false] - 是否跳过全局 loading
   * @returns {Promise} 订单状态响应 { StatusCode: number, Card: string|null }
   * StatusCode: 0=未支付, 1=已支付, 2=已过期, 3=已开卡
   */
  getOrderStatus(orderNo, options = {}) {
    return apiClient.get('/orders/query-order-status/', {
      params: { order_no: orderNo },
      skipLoading: options.skipLoading || false
    })
  }
}
